import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { HrisLocationList } from '../../../../entities/v1/HrisLocationList';

export interface ListParams {
  name?: string;
  page?: number;
  pageSize?: number;
}

export class HrisLocationService {
  public static list(params: ListParams) {
    return ApiService.get<HrisLocationList>(
      '/api/v1/applicant_tracking/hris_locations',
      snakecaseKeys(params),
    );
  }
}
